import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { genURL, gengetURLTEST } from "../_getjson.js";
import axios from 'axios'
import MaterialUIPickers from "../Components/CustomDatepicker/MaterialUIPickers"
import Backdrop from '../Components/CustomBackdrop/Barckdrop'
import Moment from 'moment';
import Grid from '@mui/material/Grid';
require("./../_css/PopUpOther.css");
export const ReDate = (TimeStamp) => {
  let dataRe = Moment(TimeStamp, 'YYYY-MM-DD').add(543, "year").format('DD/MM/YYYY')
  return dataRe
};
export const startdate = () => {
  let myDate = Moment().startOf("month").add(543, "year").format('DD/MM/YYYY')
  return myDate
}
const ReDate2 = (date) => {
  let dataRe = Moment(date, 'DD/MM/YYYY').add(-543, "year").format('YYYY-MM-DD')
  return dataRe;
};
const mystyle = {
  paddingTop: '0px',
};
export default class SearchDoc extends React.Component {
  constructor(props) {
    super(props);
    this.onAddBucket = this.onSearch.bind(this);
    this.DOCNO1 = React.createRef();
    this.DOCNO2 = React.createRef();
    this.DOCGROUP = React.createRef();
    this.DEPARTMENT = React.createRef();
    this.SITECODE = React.createRef();
    this.top = React.createRef("");
    this.state = {
      rows: [],
      Htext: "",
      _from: "",
      hiddenF: false,
      hiddenT: true,
      paybill: true,
      receipt: true,
      openBackdrop: false,
      DATE1: startdate(),
      DATE2: '',

    }
  }
  componentDidMount() {
    this.setState({ _from: this.props.from });
    setTimeout(() => {
      this.onSearch();
    }, 200);
  }

  onClose = () => {
    this.props.closePopup();
  };
  ViewCSTV = (from) => {
    console.log(from);
    var tablename = ""
    if (from === "CSPAYMENT") {
      this.setState({ Htext: "บันทึกจ่ายชำระหนี้" });
      tablename = "CSAPOTHERDEBT/SEARCH?"
    }
    if (from === "CSAPOTHERDEBT") {
      this.setState({ Htext: "บันทึกรับเงินล่วงหน้า/เงินมัดจำ" });
      tablename = "CSAPOTHERDEBT/SEARCH?"
    }
    return tablename
  };

  onSearch = () => {
    this.setState({ openBackdrop: true })
    var url = this.ViewCSTV(this.props.from);
    url += "&DATE1=" + ReDate2(this.state.DATE1)//01/10/2564 redate 2021-10-01
    url += "&DATE2=" + ReDate2(this.state.DATE2)//05/10/2564 redate 2021-10-05
    url += "&DOCNO1=" + this.DOCNO1.current.value;
    url += "&DOCNO2=" + this.DOCNO2.current.value;
    // url += "&DEPARTMENT=" + this.DEPARTMENT.current.value;
    // url += "&SITECODE=" + this.SITECODE.current.value;
    url += "&DOCGROUP=" + this.DOCGROUP.current.value;
    url += "&TOP=" + this.top.current.value;
    console.log(genURL(url));
    axios.get(genURL(url), { timeout: 60000 }).then(res => {
      if (res.data) {
        this.setState({ rows: res.data });
        this.setState({ openBackdrop: false })
      } else {
        this.setState({ openBackdrop: false })
      }
    }).catch(error => {
      this.setState({ openBackdrop: false })
      console.log(error);
    });
  };
  SelectSetData = (data1, data2) => {
    switch (data1) {
      case "Calendar1":
        console.log('Calendar1', data2);
        this.setState({ DATE1: data2 })
        break;
      case "Calendar2":
        console.log('Calendar2', data2);
        this.setState({ DATE2: data2 })
        break;
      default:
        break;
    }
  };
  onSelectRow = (data) => {
    // this.props.Get_Popup(data);
    // this.props.closePopup();
    let resdata = []
    resdata.push(false)
    resdata.push(data)
    this.props.resdata(resdata)
  };
  KeyUp = (e) => {
    switch (e.target.id) {
      case "DOCNO1":
        this.DOCNO2.current.value = e.target.value;
        break;
      default:
        break;
    }
    if (e.key === "Enter") {
      this.onSearch();
    }
  };
  render() {
    const indexN = (_0, _1, _2, index) => {
      return (<div>{index + 1}</div>)
    }
    return (
      <div className='popup' >
        <Backdrop open={this.state.openBackdrop} />
        <div className='popup_inner'>
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1"><i className="fas fa-search" > {this.state.Htext}  </i></div>
            <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
          </div>
          <div className="panel-body divTable" align="right">
            <div className="row" >
              <div style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                <Grid container spacing={2}>
                  <Grid item xs={6} >
                    <MaterialUIPickers title="วันที่"
                      DateValue={e => this.SelectSetData("Calendar1", e)}
                      defaultdate={this.state.DATE1} />
                  </Grid>
                  <Grid item xs={6}>

                    <MaterialUIPickers title="ถึง"
                      DateValue={e => this.SelectSetData("Calendar2", e)}
                      defaultdate={this.state.DATE2} />

                  </Grid>
                  <Grid item xs={6} style={mystyle}>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                      <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                        <span className="input-group-addon"> เลขที่เอกสาร : </span>
                        <input
                          type="text"
                          className="form-control"
                          id="DOCNO1"
                          ref={this.DOCNO1}
                          onKeyUp={this.KeyUp}
                        />
                        <span className="input-group-addon icon">
                          <i className="fab fa-expeditedssl"></i>
                        </span>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={6} style={mystyle}>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                      <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                        <span id="iconCreditCode" className="input-group-addon ">
                          ถึง :
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="DOCNO2"
                          ref={this.DOCNO2}
                          onKeyUp={this.KeyUp}
                        />
                        <span className="input-group-addon icon">
                          <i className="fab fa-expeditedssl"></i>
                        </span>
                      </div>
                    </div>

                  </Grid>
                  <Grid item xs={6} style={mystyle}>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                      <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                        <span id="iconCreditCode" className="input-group-addon ">  กลุ่มเอกสาร :</span>
                        <input type="text" className="form-control" id="DOCGROUP" ref={this.DOCGROUP} onKeyUp={this.KeyUp} />
                        <span className="input-group-addon icon">
                          <i className="fab fa-expeditedssl"></i>
                        </span>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={6} style={mystyle}>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                      <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                        <span className="input-group-addon">จำนวนรายการ : </span>
                        <input type="text" className="form-control" ref={this.top} />
                        <span className="input-group-addon icon">
                          <i className="fab fa-expeditedssl"></i>
                        </span>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
            <button className="PUSDbtn" onClick={this.onSearch.bind(null)}>
              <i className="fas fa-search"> ค้นหา </i>
            </button>
            <div className="tess">
              <BootstrapTable
                data={this.state.rows}
                options={{ onRowClick: this.onSelectRow, noDataText: "ไม่พบข้อมูล", }}
                height="580"
                hover
                condensed
              >
                {/* <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="40" dataField="C0" isKey></TableHeaderColumn> */}
                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="40" dataFormat={indexN} ></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField="DOCDATE"> วันที่เอกสาร</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="130" isKey dataField="DOCNO"> เลขที่เอกสาร</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="130" dataField="APCODE" > รหัสเจ้าหนี้</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="130" dataField="APNAME" > ชื่อเจ้าหนี้</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField="REMARK"> หมายเหตุ</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="130" dataField="BATHPAYAMOUNT2"> รวมเงินทั้งสิ้น</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        </div>
      </div >
    );
  }
}
